/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-03-22 19:09:20
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-12-04 17:08:35
 */
import config from './config/course'
import axios from '@/utils/request'
export const myClassList = params => axios.post(config.myClass, params) // 课程列表
export const category = params => axios.post(config.productCategory, params) // 课程分类
export const banner = params => axios.post(config.banner, { platform: 1, ...params }) // banner
export const myCourseDetail = params => axios.post(config.myCourseDetail, params) // 课程详情
export const videoPlayUrl = params => axios.post(`${config.videoPlayUrl}/${params.vid}`) // 获取播放地址
export const videoPlayUrl_ksb = params => axios.post(config.videoPlayUrl_ksb, params) // 获取播放地址-课师宝
export const videoPlayUrl_ali = params => axios.post(`${config.videoPlayUrl_ali}/${params.vid}`) // 获取播放地址-阿里
export const recordUpdate = params => axios.post(config.recordUpdate, params) // 课程记录
export const collection = params => axios.post(config.collection, params) // 课程记录
export const freeCourse = params => axios.post(config.freeCourse, params) // 限时免费
export const classDetail = params => axios.post(config.classDetail, params) // 班级详情
export const currentDuration = params => axios.post(config.currentDuration, params) // 节当前观看时长
export const recommond = params => axios.post(config.recommond, params) // 首页热门课程
export const organizations = params => axios.post(config.organizations, params) // 学院
export const classList = params => axios.post(config.classList, params) // 班级列表
export const cousreList = params => axios.post(config.cousreList, params) // 课程列表
export const collegeDetail = params => axios.post(config.collegeDetail, params) // 学院详情
export const collegeCourse = params => axios.post(config.collegeCourse, params) // 学院课程列表
export const collegeClass = params => axios.post(config.collegeClass, params) //
export const courseDetail = params => axios.post(config.courseDetail, params) //
export const coursePlayDetail = params => axios.post(config.coursePlayDetail, params) //
export const collegeTeacher = params => axios.post(config.collegeTeacher, params) //
export const teacherInfo = params => axios.post(config.teacherInfo, params) //
export const teacherCourse = params => axios.post(config.teacherCourse, params) //
export const videoCategory = params => axios.post(config.videoCategory, params) //
export const shortVideo = params => axios.post(config.shortVideo, params) //
export const shortVideoLike = params => axios.post(config.shortVideoLike, params) //
export const shortVideoUnLike = params => axios.post(config.shortVideoUnLike, params) //
export const shortVideoRecord = params => axios.post(config.shortVideoRecord, params) //
export const orgvideo = params => axios.post(config.orgvideo, params) //
export const orgvideoLastid = params => axios.post(config.orgvideoLastid, params) //
export const orgvideoSum = params => axios.post(config.orgvideoSum, params) //
export const studyHistory = params => axios.post(config.studyHistory, params) //
export const shortVideoById = params => axios.post(config.shortVideoById, params) //
export const shortVideoShare = params => axios.post(config.shortVideoShare, params) //
export const shortVideoOpenShare = params => axios.post(config.shortVideoOpenShare, params) //
export const orderDetail = params => axios.post(config.orderDetail, params) //
export const orderCancel = params => axios.post(config.orderCancel, params) //
export const shortvideoLastid = params => axios.post(config.shortvideoLastid, params) //
export const mybuycourse = params => axios.post(config.mybuycourse, params) //
export const addCollect = params => axios.post(config.addCollect, params) //
export const randShortvideoLastid = params => axios.post(config.randShortvideoLastid, params) //
export const getLiveOnlineUser = params => axios.post(config.liveOnlineUser, params) //
//加入群聊
export const getJoinChat = params => axios.post(config.joinChat, params).then(res => res.data)
//im查询用户
export const getSearchUser = params =>
  axios.post(`/course/identify/im/user/query/by/imaccount`, params).then(res => res.data)

export const getVideoPlayInfo = params =>
  axios.post(config.videoPlayInfo, params).then(res => res.data)
